import React from "react";
import img from "../../../Assets/Images/404.jpg";

const NotFound = () => {
  return (
    <div>
      <div className="container text-center">
        <img className="" src={img} alt="" />
      </div>
    </div>
  );
};

export default NotFound;
